/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

// ============================================================
// Homepage Scrollytelling — GSAP ScrollTrigger
//
// Manages scroll-driven animations for:
//   1. Benefits section (video/text transitions)
//   2. Product Summary section (icon/text/background transitions)
//   3. How It Works section (step transitions)
//
// Dependencies: gsap.min.js, ScrollTrigger.min.js (loaded conditionally in theme.liquid)
// ============================================================

Shopify.theme.jsHomepageScrolltelling = {
  init: function($section) {
    // Guard: ensure GSAP and ScrollTrigger are loaded
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('[Homepage Scrollytelling] GSAP or ScrollTrigger not loaded');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var sectionEl = $section[0];
    var sectionType = sectionEl.dataset.scrolltellingType;

    switch (sectionType) {
      case 'benefits':
        this.initBenefits(sectionEl);
        break;
      case 'product-summary':
        this.initProductSummary(sectionEl);
        break;
      case 'how-it-works':
        this.initHowItWorks(sectionEl);
        break;
      default:
        break;
    }
  },

  // ----- Benefits Section -----
  initBenefits: function(el) {
    // TODO: Implement scroll-driven video/text transitions
    // - Pin the video container
    // - Transition overlay text at scroll breakpoints
    // - Update progress dots
    console.log('[Scrollytelling] Benefits section initialized');
  },

  // ----- Product Summary Section -----
  initProductSummary: function(el) {
    // TODO: Implement scroll-driven icon/text/background transitions
    console.log('[Scrollytelling] Product Summary section initialized');
  },

  // ----- How It Works Section -----
  initHowItWorks: function(el) {
    // TODO: Implement scroll-driven step transitions
    // - Pin the app screenshot
    // - Transition step text at scroll breakpoints
    // - Update progress dots
    console.log('[Scrollytelling] How It Works section initialized');
  },

  unload: function($section) {
    // Kill all ScrollTrigger instances in this section
    var sectionEl = $section[0];
    ScrollTrigger.getAll().forEach(function(trigger) {
      if (sectionEl.contains(trigger.trigger)) {
        trigger.kill();
      }
    });
  }
};

/******/ })();
